import { render } from "./_FastPaymentPreview.vue?vue&type=template&id=40ec4130"
import script from "./_FastPaymentPreview.vue?vue&type=script&lang=js"
export * from "./_FastPaymentPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__